// Shared @craft-form/renderer theme (passed as CraftFormProvider's `theme`
// prop) — mirrors the project's actual Bootstrap theme, the tokens that
// drive --bs-primary etc. app-wide (assets/scss/config/creative/_variables.scss),
// not Order.scss's own local $primary override, which only reaches that one
// file's Sass scope, not Bootstrap's generated CSS variables. Every form
// migrated to @craft-form/renderer should reuse this, not redefine its own.
const craftFormTheme = {
  colors: {
    primary: "#3d78e3", // $primary / $blue
    primaryContrast: "#FFFFFF",
    secondary: "#5b71b9", // $secondary / $indigo
    text: "#212529", // $body-color / $gray-900
    textMuted: "#878a99", // $gray-600 / $body-secondary-color
    background: "#FFFFFF",
    inputBackground: "#FFFFFF",
    surface: "#f3f3f9", // $body-bg
    border: "#e9ebec", // $border-color / $gray-300
    borderStrong: "#ced4da", // $gray-400
    disabled: "#adb5bd", // $gray-500
    warning: "#ffc84b", // $warning / $yellow
    warningSurface: "#fff7e4", // ~tint-color($warning, 85%)
    error: "#f17171", // $danger / $red
    success: "#67b173", // $success / $green
  },
};

export default craftFormTheme;
